<template>
  <!-- 奖品管理-详情 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="详情"
      width="800px"
      @close="closeDialog"
      center
    >
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="name" label="所在盒子名称" align="center">
        </el-table-column>
        <el-table-column label="所在盒子类型" align="center">
          <template slot-scope="{ row }">
            {{ getCategoryName(row.category_id) }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="所在盒子价格" align="center">
        </el-table-column>
        <el-table-column label="更新类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.price_up_type === 1">自动</span>
            <span v-if="row.price_up_type === 2">手动</span>
            <span v-if="row.price_up_type === 3">不更新</span>
          </template>
        </el-table-column>
      </el-table>
      <p class="null_tips" v-if="!dataList && !loading">暂无数据</p>

      <!-- 底部分页条 -->
      <el-pagination
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlLogPageChange"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { delData, getApiData, patchData, postData } from '../../http'
import ImgUpload from '@/components/common/ImgUpload'

export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      query: {//查询条件
        page: 1
      },
      dataList: undefined,//历史数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        // 打开弹窗显示数据
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      //获取开奖历史
      this.loading = true
      let params = {
        page: this.query.page
      }
      getApiData(`prize_box_price/${this.dialogInfo.id}`, params).then(res => {
        if (res) {
          this.dataList = res
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })

    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    },
    handlLogPageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.null_tips {
  text-align: center;
  line-height: 60px;
  color: #909399;
}
</style>